export const FEEDBACK_CTA = "Was this helpful?";

export const LIKE = 1;
export const DISLIKE = -1;
export const NO_FEEDBACK = 0;
